import { AddressBookEntry } from './AddressBookEntry';

export interface OrganizationConfigs {
  inactiveSensorThresholdMinutes?: number;
  inactiveLocationThresholdMinutes?: number;
  addressBookLimit?: number;
  conditionsLimit?: number;
}

export const DEFAULT_ORGANIZATION_CONFIGS: Required<OrganizationConfigs> = {
  inactiveSensorThresholdMinutes: 50,
  inactiveLocationThresholdMinutes: 30,
  addressBookLimit: 10,
  conditionsLimit: 5,
};

export interface OrganizationContact {
  emails?: string[];
  sms?: string[];
}

export class Organization {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly configs: OrganizationConfigs = {},
    public readonly contact: OrganizationContact = {},
    public readonly addressBook: AddressBookEntry[] = [],
    public readonly createdAt: Date | null = null,
    public readonly updatedAt: Date | null = null,
    public readonly createdBy?: string,
    public readonly updatedBy?: string
  ) {}

  static create(
    id: string,
    name: string,
    configs?: OrganizationConfigs,
    contact?: OrganizationContact,
    addressBook?: AddressBookEntry[]
  ): Organization {
    return new Organization(
      id,
      name,
      configs,
      contact,
      addressBook
    );
  }

  update(
    name?: string,
    configs?: OrganizationConfigs,
    contact?: OrganizationContact,
    addressBook?: AddressBookEntry[]
  ): Organization {
    return new Organization(
      this.id,
      name ?? this.name,
      configs ?? this.configs,
      contact ?? this.contact,
      addressBook ?? this.addressBook,
      this.createdAt,
      this.updatedAt,
      this.createdBy,
      this.updatedBy
    );
  }
}
